<template>
  <div class="activate">
    <AlertBar
        v-model="message.show"
        :type="message.type"
        :message="message.text"
        :detail="message.detail"
      >          
      </AlertBar>
    <Busy :value="busy"></Busy>
    <v-container
      class="d-flex align-center justify-center"
      fluid
      fill-height
      @mousedown.stop
      @keydown.stop
    > <!-- The .stops prevent the App.vue keepalives from firing on this page since we are not in a session yet -->
      <template v-if="state === 'normal'">
        <v-card class="activate__card elevation-12 align-self-center justify-self-center">
          <v-card-title>
            Activate &amp; set initial password
          </v-card-title>
          <v-card-text>
            <PasswordForm
              ref="form"
              usernameLabel="email"
              @submit-form="activate"
            >
              <v-btn
                class="action-button"
                color="primary"
                type="submit"
              >
                Activate
              </v-btn>          
            </PasswordForm>
            <br/>
            <v-row>
              <v-col cols="12" class="d-flex justify-center">
                Here by mistake?&nbsp;<router-link to="/signin">Sign in</router-link>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <template v-else-if="state === 'success'">
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="text-h4 py-4">
              <v-icon left size="64" class="pr-1" color="success">fa-solid fa-circle-check</v-icon>              
              Success!
            </p>
            <p class="text-h5 py-4">Your account activation was successful! You may now&nbsp;<router-link to="/signin">sign in</router-link> with your new password.</p>
            <p class="text-h5 py-4">Automatically redirecting to the sign-in page in {{countDown}} seconds.</p>
          </v-col>
        </v-row>
      </template>
      <template v-else-if="state === 'invalid'">
        <v-row>
          <v-col cols="12" class="text-center">
            <p class="text-h4 py-4">
              <v-icon left size="64" class="pr-1" color="error">fa-solid fa-circle-exclamation</v-icon>              
              Error!
            </p>
            <p class="text-h5 py-4">The activation link is not valid.</p>
            <p class="text-h5 py-4">Complete the sign-up process&nbsp;<router-link to="/get-started?force=true">here</router-link> to get a new link.</p>
          </v-col>
        </v-row>
      </template>      
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import { AlertBar, Busy, PasswordForm } from '@itus/ui.common'
import { buildApiUrl } from '@/components/api-url-builder'

export default {
  name: 'Activate',  
  data() {
    return {
      message: {
        show: false,
        type: 'error',
        text: ''
      },   
      busy: false,
      registrationId: null,
      activationId: null,      
      email: null,
      state: 'normal',
      countDown: 10,
      countDownTimer: null
    }
  },
  components: {
    Busy,
    PasswordForm,
    AlertBar
  },
  methods: {
    async activate() {
      if (!this.$refs.form.validate()) {
        return
      }

      let body = {
        step: 'activate',
        id: this.registrationId,
        activation: this.activationId,        
        password: this.$refs.form.newPassword
      }

      this.busy = true
      this.message.show = false
      axios.post(buildApiUrl('/api/register'), body)
        .then(() => {
          this.state = 'success'
          this.countDownTimer = setInterval(this.decrement, 1000)          
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.toLowerCase().includes('password')) {
            this.message.text = err.response.data.error
            this.message.show = true
          } else {
            this.state = 'invalid'            
          }          
        })
        .finally(() => this.busy = false)
    },
    decrement() {
      this.countDown = this.countDown - 1
      if(this.countDown <= 0) {
        if(this.countDownTimer)
          clearInterval(this.countDownTimer)
        
        this.$router.push('/signin')
      }        
    }
  },
  mounted() {
    this.registrationId = this.$route.query?.registrationId
    this.activationId = this.$route.query?.activationId    
    
    this.countDownTimer = null
    this.countDown = 10
  }
}
</script>
<style lang="scss" scoped>
.activate {
  height: 100%
}
.activate__alert {
  position: fixed;
  width: 100%;
  z-index: 1;
}
.activate__card {
  max-width: 450px;
}
.action-button {
  width: 100%;
}
</style>